module.exports = __webpack_public_path__ + "static/img/topBanner3.8a28f67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/topBanner3.png
// module id = 7t3p
// module chunks = 2